import type { ActivationAlertsContractNewsTopic } from "@similarweb/pro-api-client";

import type { NewsType } from "../types";

export const NEWS_TYPES: NewsType[] = ["Story", "PR", "Mention"];

export const TOPICS: ActivationAlertsContractNewsTopic[] = [
    "Awards",
    "BoardAppointments",
    "ClassActions",
    "ClosingDown",
    "Conferences",
    "ContractsAndAgreements",
    "DataBreaches",
    "Esg",
    "ExpansionsAndLaunches",
    "FinancialResults",
    "InvestmentsAndFunding",
    "LeadershipChanges",
    "LeadershipSays",
    "LegalAndRegulatory",
    "MergersAndAcquisitions",
    "News",
    "Partnerships",
    "Philanthropy",
    "ProductRecalls",
    "Rebrand",
    "Workforce",
];
